import { apis2 } from '.';
import http from './http';

export default class OpenTicketReportApi {
  static statisticsTicketMetrics (param: {
    startDate: string | null,
    endDate: string | null
  }): Promise<{
    handleTimeoutTicketCount: number,
    responseTimeoutTicketCount: number,
    unrespondedTicketCount: number,
    newTicketCount: number,
    goodRate: number
  }> {
    return http.post(apis2.OpenTicketReportApi.statisticsTicketMetrics, { param })
  }

  static statisticsUnfinishedTicket (param: {
    startDate: string | null,
    endDate: string | null,
    page: {
      pageNumber: number,
      pageSize: number
    }
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsUnfinishedTicket, { param })
  }

  static statisticsTicketTypePercentage (param: {
    startDate: string | null,
    endDate: string | null
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsTicketTypePercentage, { param })
  }

  static statisticsTicketRequestLocationDistribution (param: {
    province?: string | null,
    startDate: string | null,
    endDate: string | null
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsTicketRequestLocationDistribution, { param })
  }

  static statisticsEngineerGeoLocationDistribution (param: {
    province?: string | null,
    startDate: string | null,
    endDate: string | null
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsEngineerGeoLocationDistribution, { param })
  }

  static statisticsServiceCatalogTicket (param: {
    startDate: string | null,
    endDate: string | null,
    page: {
      pageNumber: number,
      pageSize: number
    }
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsServiceCatalogTicket, { param })
  }

  static statisticsEngineerTicketInfo (param: {
    seatStatus: string | null
    page: {
      pageNumber: number,
      pageSize: number
    }
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsEngineerTicketInfo, { param })
  }

  static statisticsTicketEvaluate (param: {
    startDate: string | null,
    endDate: string | null,
    evaluateScores: Array<number | null>,
    page: {
      pageNumber: number,
      pageSize: number
    }
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsTicketEvaluate, { param })
  }

  static statisticsTicketNumber (param: {
    startDate: string | null,
    endDate: string | null,
    dateType: string | null
  }) {
    return http.post(apis2.OpenTicketReportApi.statisticsTicketNumber, { param })
  }
}
